import React from 'react';
import { SideBarCSS } from '../styles/style';
import { PDF_TEXTS } from '../utils/texts';

interface ReportLogoProps {
  selectedIcon: string | null;
  pdfIconBase64: string;
  activePlanName: string;
  planDetails: any;
}

export const ReportLogo: React.FC<ReportLogoProps> = ({
  selectedIcon,
  pdfIconBase64,
  activePlanName,
  planDetails
}) => {
  const isAgency =
    activePlanName === planDetails?.agency ||
    activePlanName === planDetails?.expertPlus ||
    activePlanName === planDetails.enterprise;
  const customIcon =
    selectedIcon ||
    (pdfIconBase64 && pdfIconBase64.length > 0 ? pdfIconBase64 : null);

  if (customIcon && isAgency) {
    return (
      <div style={SideBarCSS.logoContainer}>
        <img
          src={customIcon}
          alt={PDF_TEXTS.sidebar.customIcon.alt}
          style={SideBarCSS.logoImage}
        />
      </div>
    );
  } else {
    return (
      <div style={SideBarCSS.logoContainer}>
        <img
          src={`${process.env.PUBLIC_URL}/static/images/logo/new-logo.svg`}
          alt="Logo"
          style={SideBarCSS.logoImage}
        />
      </div>
    );
  }
};
